import { Box, BrightyStepButtonLink, BrightyStepLabel, Step, Stepper } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiStandingOrder } from '../../../openapi';

export enum StandingOrderSteps {
  origin,
  destinations,
}

export function StandingOrderStepper({
  order,
  activeStep,
}: {
  order?: ApiStandingOrder;
  activeStep: StandingOrderSteps;
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper alternativeLabel activeStep={activeStep} nonLinear>
        <Step>
          {order ? (
            <BrightyStepButtonLink
              to="/account/standing-orders/$orderId/$step"
              params={{ orderId: order.id, step: 'origin' }}
            >
              {t('Origin')}
            </BrightyStepButtonLink>
          ) : (
            <BrightyStepLabel>{t('Origin')}</BrightyStepLabel>
          )}
        </Step>
        <Step>
          {order ? (
            <BrightyStepButtonLink
              to="/account/standing-orders/$orderId/$step"
              params={{ orderId: order.id, step: 'destinations' }}
            >
              {t('Destinations')}
            </BrightyStepButtonLink>
          ) : (
            <BrightyStepLabel>{t('Destinations')}</BrightyStepLabel>
          )}
        </Step>
      </Stepper>
    </Box>
  );
}
